
































































import { Component, Vue } from "vue-property-decorator";

import { BaseGridComponent, GridPagerCpt, GridTableCpt } from "@/core/components";
import { WorkshopCollectionModel, WorkshopFilterModel } from "@/core/models";
import { WorkshopService } from "@/core/services";
import { WorkflowGridFiltersCpt, WorkshopStatusCpt } from "./";
import moment from "moment";

@Component({
  components: {
    GridPagerCpt,
    WorkflowGridFiltersCpt,
    WorkshopStatusCpt,
    GridTableCpt,
  },
})
export default class WorkshopGridCpt extends BaseGridComponent<WorkshopCollectionModel, WorkshopFilterModel> {
  filter = {} as WorkshopFilterModel;
  columns = [
    { label: "Id", prop: "id", slot: "id", width: "60px", sortable: true },
    { label: "Workshop Date", prop: "eventDate", width: "140px", slot: "eventDate", sortable: true },
    { label: "Workshop Region", prop: "regionLookup.text", width: "150px", slot: "regionName", sortable: true },
    { label: "Workshop County", prop: "countyLookup.text", width: "150px", slot: "countyName", sortable: true },
    { label: "Status", prop: "workshopStatusLookup.text", slot: "workshopStatusName", sortable: true },
    { label: "Facilitator", prop: "userDetail.firstName", width: "110px", slot: "facilitatorName", sortable: true },
    { label: "# of Clients", prop: "noOfCompanies", slot: "noOfCompanies", sortable: false },
    { label: "Actions", prop: "actions", slot: "actions", width: "95px" },
  ];

  async created() {
    this.initializeFilters();
    this.load();
  }

  private formatEventDate(eventDate: any) {
    return moment(eventDate).format("DD MMMM YYYY");
  }

  private filterUpdated(filter: WorkshopFilterModel) {
    this.filter = filter;
    this.filter.page = 1;
    this.load();
  }

  private load() {
    this.initialize((filter: WorkshopFilterModel) => WorkshopService.filterWorkshops(filter), "workshops", this.filter);
  }

  private initializeFilters() {
    if (this.filter) {
      const query = this.$route.query as any;
      this.filter.regionId = !!query.regionId ? parseInt(query.regionId, 10) : 0;
      this.filter.countyId = !!query.countyId ? parseInt(query.countyId, 10) : 0;
      this.filter.workshopStatusId = !!query.workshopStatusId ? parseInt(query.workshopStatusId, 10) : 0;
      this.filter.search = query.search || "";
      this.filter.startDate = query.startDate ? new Date(query.startDate) : ("" as any);
      this.filter.endDate = query.endDate ? new Date(query.endDate) : ("" as any);
      this.filter.sortBy = query.sortBy || "EventDate";
      this.filter.sortOrder = query.sortOrder || "desc";
    }
  }
}
